<div class="staff-shell">
  <div class="sl-sidebar-backdrop" *ngIf="mobileSidebarOpen" (click)="closeMobileSidebar()"></div>

  <aside class="sl-sidebar" [class.sl-sidebar-open]="mobileSidebarOpen">
    <div class="sl-brand" (click)="goToDefaultScreen()">
      <div class="sl-brand-logo-wrap">
        <img *ngIf="brand.id" [src]="brand.menuFullLogoPath" alt="{{ brand.name }}" class="sl-brand-logo" />
      </div>
      <span class="sl-beta-pill">BETA</span>
    </div>

    <div class="sl-nav-scroll">
      <div *ngIf="menu.dashboard">
        <div class="sl-nav-section-title">{{ 'overview' | translate }}</div>
        <div class="sl-nav-list">
          <a class="sl-nav-item" routerLink="/staff/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <span class="sl-nav-icon"><i class="ph ph-house"></i></span> {{ 'dashboard' | translate }}
          </a>
        </div>
      </div>

      <div *ngIf="menu.allClasses || showMyTimetable">
        <div class="sl-nav-section-title">{{ 'myClasses' | translate }}</div>
        <div class="sl-nav-list">
          <a class="sl-nav-item" *ngIf="menu.allClasses" routerLink="/staff/classes" [class.active]="isInsideClassSection">
            <span class="sl-nav-icon"><i class="ph ph-squares-four"></i></span> {{ 'allClasses' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showMyTimetable" routerLink="/staff/my-timetable" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-calendar-blank"></i></span> {{ 'myTimetable' | translate }}
          </a>
        </div>
      </div>

      <div *ngIf="showBroadcast || showAcademicCalendar || showFeeCollection || showFeeReports || showVehicleManagement || showStudentCheckIn || showSearch || showViewStaffAttendance || showLeaveManagement">
        <div class="sl-nav-section-title">{{ 'school' | translate }}</div>
        <div class="sl-nav-list">
          <a class="sl-nav-item" *ngIf="showBroadcast" routerLink="/staff/broadcast" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-megaphone"></i></span> {{ 'broadcast' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showAcademicCalendar" routerLink="/staff/academic-calendar" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-calendar"></i></span> {{ 'academicCalendarLabel' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showFeeCollection" routerLink="/staff/fees" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-currency-circle-dollar"></i></span> {{ 'staffFeesCollection' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showFeeReports" routerLink="/staff/fees-report" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-file-text"></i></span> {{ 'feesReports' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showVehicleManagement" routerLink="/staff/transport" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-bus"></i></span> {{ 'transport' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showStudentCheckIn" routerLink="/staff/checkin" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-sign-in"></i></span> {{ 'checkInCheckOut' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showViewStaffAttendance" routerLink="/staff/view-attendance" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-clock"></i></span> {{ 'viewStaffAttendance' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showLeaveManagement" routerLink="/staff/leave-management" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-calendar-check"></i></span> {{ 'leaveManagement' | translate }}
          </a>
          <a class="sl-nav-item" *ngIf="showSearch" routerLink="/staff/search" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-magnifying-glass"></i></span> {{ 'search' | translate }}
          </a>
        </div>
      </div>

      <div *ngIf="doorwayServiceEnabled || trackifyServiceEnabled || nexusServiceEnabled">
        <div class="sl-nav-section-title">{{ 'extensionServices' | translate }}</div>
        <div class="sl-nav-list">
          <a class="sl-nav-item" *ngIf="doorwayServiceEnabled" (click)="openExternalService('DOORWAY')" title="Visitor Management">
            <span class="sl-nav-icon"><img src="assets/img/doorway.png" class="sl-service-logo" alt=""></span> Visitor Management
          </a>
          <a class="sl-nav-item" *ngIf="trackifyServiceEnabled" (click)="openExternalService('TRACKIFY')" title="Trackify">
            <span class="sl-nav-icon"><img src="assets/img/track.png" class="sl-service-logo" alt=""></span> Trackify
          </a>
          <a class="sl-nav-item" *ngIf="nexusServiceEnabled" (click)="openExternalService('LIBRARY_MANAGEMENT')" title="Library Management">
            <span class="sl-nav-icon"><img src="assets/img/nexus-logo.png" class="sl-service-logo" alt=""></span> Library Management
          </a>
        </div>
      </div>

      <div>
        <div class="sl-nav-section-title">{{ 'account' | translate }}</div>
        <div class="sl-nav-list">
          <a class="sl-nav-item" *ngIf="showProfile" routerLink="/staff/profile" routerLinkActive="active">
            <span class="sl-nav-icon"><i class="ph ph-user"></i></span> {{ 'myProfile' | translate }}
          </a>
          <a class="sl-nav-item" (click)="requestLogout()">
            <span class="sl-nav-icon"><i class="ph ph-sign-out"></i></span> {{ 'logout' | translate }}
          </a>
        </div>
      </div>
    </div>

    <div class="sl-sidebar-footer">{{ brand.name }} &copy; {{ appVersion }}</div>
  </aside>

  <div class="sl-content">
    <header class="sl-topbar">
      <button type="button" class="sl-hamburger-btn" title="{{ 'menu' | translate }}" (click)="toggleMobileSidebar()">
        <i class="ph ph-list"></i>
      </button>

      <div class="sl-profile" *ngIf="showProfile" routerLink="/staff/profile">
        <div class="sl-avatar" [class.sl-avatar-photo]="staffImage">
          <img *ngIf="staffImage" [src]="staffImage" alt="{{ staffName }}" />
          <ng-container *ngIf="!staffImage">{{ staffInitials }}</ng-container>
        </div>
        <div class="sl-profile-text">
          <span class="sl-profile-name">{{ staffName }}</span>
          <span class="sl-profile-role">{{ schoolName || staffRole }}</span>
        </div>
      </div>

      <div class="sl-search" *ngIf="showSearch" routerLink="/staff/search">
        <i class="ph ph-magnifying-glass"></i>
        <input type="text" placeholder="{{ 'searchStudentsStaffPlaceholder' | translate }}" readonly />
      </div>

      <div class="sl-topbar-actions">
        <button class="sl-icon-btn" *ngIf="showBroadcast" routerLink="/staff/broadcast" title="{{ 'broadcast' | translate }}">
          <i class="ph ph-megaphone"></i>
          <span class="sl-unread-dot" *ngIf="hasUnreadBroadcast"></span>
        </button>
        <app-language-dropdown iconStyle="globe"></app-language-dropdown>
        <button class="sl-icon-btn" title="{{ 'logout' | translate }}" (click)="requestLogout()">
          <i class="ph ph-sign-out"></i>
        </button>
      </div>
    </header>

    <main class="sl-main">
      <router-outlet></router-outlet>
    </main>
  </div>

</div>

<div class="sl-modal-overlay" *ngIf="showLogoutConfirm" (click)="cancelLogout()">
  <div class="sl-modal" (click)="$event.stopPropagation()">
    <div class="sl-modal-icon"><i class="ph ph-sign-out"></i></div>
    <h3 class="sl-modal-title">{{ 'confirmLogoutTitle' | translate }}</h3>
    <p class="sl-modal-text">{{ 'confirmLogoutMessage' | translate }}</p>
    <div class="sl-modal-actions">
      <button class="sl-modal-btn sl-modal-btn-secondary" (click)="cancelLogout()">{{ 'cancel' | translate }}</button>
      <button class="sl-modal-btn sl-modal-btn-danger" (click)="confirmLogout()">{{ 'logout' | translate }}</button>
    </div>
  </div>
</div>

<app-staff-admin-verify-modal></app-staff-admin-verify-modal>
